import { FOOD_HUES } from '@/domain/storefront/storefront-colors';
import type { IFoodHueId } from '@/domain/storefront/storefront-colors';
import { normalizeBrand } from './design-draft';

export type ISwatchId = 'logo' | IFoodHueId | 'current';

export interface IColorSwatch {
  id: ISwatchId;
  hex: string;
}

/**
 * «Del logo» (when the logo has a colour), the 6 food hues (minus one equal to
 * the logo colour), then «Actual» when the saved colour is none of them.
 */
export function colorSwatches(input: {
  logoColor?: string | null;
  savedBrand: string;
}): IColorSwatch[] {
  const list: IColorSwatch[] = [];
  const logo = input.logoColor ? normalizeBrand(input.logoColor) : null;
  if (logo) list.push({ id: 'logo', hex: logo });
  for (const hue of FOOD_HUES)
    if (hue.hex !== logo) list.push({ id: hue.id, hex: hue.hex });
  const saved = normalizeBrand(input.savedBrand);
  if (!list.some((swatch) => swatch.hex === saved))
    list.push({ id: 'current', hex: saved });
  return list;
}

/** The swatch showing `brand`, or «Otro color». */
export function selectedSwatch(
  swatches: readonly IColorSwatch[],
  brand: string
): ISwatchId | 'other' {
  const hex = normalizeBrand(brand);
  return swatches.find((swatch) => swatch.hex === hex)?.id ?? 'other';
}
